<template>
  <div class="pa-5 mt-3 form-container">
    <div v-if="unexpectedError" class="text-medium">
      ご依頼の処理でエラーが発生しました。<br />
      お手数ですが最初から再度お手続きをお願いいたします。
      <AppButton2
        color="primary"
        @click="goToTop"
      >
        TOPに戻る
      </AppButton2>
    </div>
    <div v-else-if="!captureResult">
      支払処理を完了しています。しばらくお待ちください。
    </div>
    <div v-else class="text-medium">
      <template v-if="!captureResult.clientCharge || captureResult.clientCharge.isError">
        決済手続きでエラーが発生いたしました。<br /><br />
        <div class="my-2">
          ご登録のクレジットカードでは決済できないため、ご希望のお手続きは完了しておりません。<br />
          ご登録クレジットカード情報のご確認やご登録のクレジットカード会社様にご確認ください。<br />
        </div>
        <div>
          <AppButton2
            color="primary"
            @click="goToCardInfo"
          >
            カード情報の変更
          </AppButton2>
          <AppButton2
            color="primary"
            @click="goToTop"
          >
            TOPに戻る
          </AppButton2>
        </div>
      </template>
      <template v-else>
        ご依頼の処理を完了いたしました。<br /><br />
        <div>
          <AppButton2
            color="primary"
            @click="goToTop"
          >
            TOPに戻る
          </AppButton2>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AppButton2 from '@/components/Common/AppButton2.vue'
import gql from 'graphql-tag'

export default {
  components: { AppButton2 },
  data () {
    return {
      captureResult: null,
      unexpectedError: false,
    }
  },
  computed: {
    paymentId () {
      return Number(this.$route.query.id)
    },
    token () {
      return this.$route.query.t
    }
  },
  mounted () {
    if (this.paymentId && this.token) {
      this.capture()
    } else {
      this.$router.replace({ name: 'home' })
    }
  },
  methods: {
    goToCardInfo () {
      this.$router.replace({ name: 'home-member-info-credit-card' })
    },
    goToTop () {
      this.$router.replace({ name: 'home' })
    },
    async capture () {
      await this.$doLoading(async () => {
        await this.$showGqlError(async () => {
          try {
            const data = await this.$apollo.mutate({
              mutation: gql`
                mutation captureSecurePayment($id: Int! $token: String!) {
                  captureSecurePayment(id: $id token: $token) {
                    clientCharge {
                      isError
                    }
                    fromUrl
                  }
                }
              `,
              variables: {
                id: this.paymentId,
                token: this.token
              }
            })
            this.captureResult = data.data.captureSecurePayment
          } catch (e) {
            // the error message will be handled in $showGqlError,
            // just set the other error flag so that appropriate message is shown
            this.unexpectedError = true
            throw e
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.no-bullet {
  list-style-type: none;
}
</style>
